<div class="new_panel" [ngClass]="cssClass">
  @if (caption) {
    <div class="panel__header">
      <div class="row no-gutters gutters-2 align-items-center">
        <div [ngClass]="{'col-md-6 col-lg-8 col-xl-8': headerRight, 'col-md-12': !headerRight}">
          @if (icon) {
            <i class="{{icon}}"></i>
            } {{caption}}
          </div>
          @if (headerRight) {
            <div class="col-md-6 col-lg-4 col-xl-4" >
              <ng-template [ngTemplateOutlet]="headerRight"></ng-template>
            </div>
          }
        </div>
      </div>
    }
    <div class="panel__content" [ngClass]="cssBody">
      <ng-content></ng-content>
    </div>
    @if (footer) {
      <div class="panel__footer">
        <ng-template [ngTemplateOutlet]="footer"></ng-template>
      </div>
    }
  </div>
